import styled from "styled-components";

import { Combobox } from "@similarweb/ui-components";

// Keep the options body at a constant height (matches Combobox.Content's built-in max-height)
// so the popover doesn't resize while filtering, which otherwise makes floating-ui flip it
// between top/bottom and causes a visible flicker.
export const StyledHeightComboboxContent = styled(Combobox.Content)`
    min-height: 260px;
`;
